export default "__VITE_ASSET__BY06sMF5__"